/**
 * This file exports components View and Text which wrap <div> and <span>.
 * We do this so that someday in the future we can use these components with
 * React Native.
 *
 * Inspired by https://github.com/necolas/react-native-web. We use aphrodite
 * StyleSheets instead.
 */

module.exports = {
  Text: require('./text'),
  View: require('./view')
};


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/src/fake-react-native-web/index.js
 ** module id = 357
 ** module chunks = 0 2
 **/